/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, string, bool,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
    },
    FrontCardSide: {
        width: '384px',
        maxHeight: '100%',
        minHeight: '100%',
        display: 'flex',
        color: theme.palette.cgc?.white || 'white',
        boxSizing: 'border-box',
        justifyContent: 'space-around',
        alignItems: 'center',
        background: theme.palette.cgc?.bgCardFront || '#c4c4c4',
        [theme.breakpoints.down(1660)]: {
            width: '350px',
            maxHeight: '385px',
            minHeight: '350px',
        },
    },
    FrontCardSideHorizontal: {
        width: '380px',
        transform: 'rotate(90deg)',
    },
    image: {
        width: '100%',
        maxHeight: '100%',
    },
});

const CardFrontSide = ({ classes, selectedCard, isHorizontal }) =>  {
    if (!selectedCard?.uid) {
        return null;
    }
    return ((
        <Grid className={classes.container}>
            <Grid className={`${classes.FrontCardSide} ${isHorizontal ? classes.FrontCardSideHorizontal : ''}`} style={isHorizontal ? {  } : null}>
                <img
                    src={selectedCard.front_view?.card_image?.url}
                    className={classes.image}
                    alt={selectedCard.title}
                />
            </Grid>
        </Grid>
    )
    );
};

CardFrontSide.propTypes = {
    classes: object.isRequired,
    selectedCard: shape({
        front_view: shape({
            card_image: shape({
                url: string,
            }),
        }),
        title: string,
        card_orientation: string,
        uid: string,
    }),
    isHorizontal: bool.isRequired,
};
CardFrontSide.defaultProps = {
    selectedCard: {},
};

export default withStyles(styles)(CardFrontSide);
